<template>
  <el-dialog title="提示" :visible.sync="show" width="600px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    <div style="text-align: center">
      <img src="@/assets/record/wran.png" alt="" style="width: 60px">
    </div>
    <div style="color: #969696;font-size: 16px;text-align: center;margin-top: 20px">
      本次操作会删除该项目下的所有记工记账数据。<br>
      确定是{{ $store.state.user.telPhone }}的用户吗？
    </div>
    <el-form :model="form" :rules="rules" ref="form">
      <div style="display: flex;margin: 30px 50px 8px;">
        <div style="flex:1">
          <el-form-item prop="code" :class="erroinfo?'is-error':''">
              <el-input placeholder="输入验证码" v-model="form.code" clearable @focus="erroinfo=''"/>
            <span v-if="erroinfo" class="el-form-item__error">{{erroinfo}}</span>
          </el-form-item>

        </div>
        <div style="width: 140px;margin-left: 20px">
          <el-button class="borderlan" :disabled="disabled!=0" @click="getcode">{{disabled?`${disabled}s后重新获取`:'获取验证码'}}</el-button>
        </div>

      </div>
    </el-form>
    <div slot="footer" style="text-align: center;margin-top: -20px;margin-bottom: 20px">
      <el-button @click="show=false;">取消</el-button>
      <el-button type="primary" @click="center()" style="margin-left: 20px">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {api} from '@/api/apiRecord.js'
export default {
  name: "delTips",
  data() {
    return {
      show: false,
      form:{
        phoneNumber:this.$store.state.user.telPhone,
        code: ""
      },
      rules:{
        code: [
          { required: true, message: '验证码不能为空'},
          { pattern: /[0-9]{4,6}/, message: '验证码输入不正确' }
        ]
      },
      disabled:0,
      time:'',//计时器
      erroinfo:'',//短信验证错误提示
    }
  },
  watch:{
    show(v){
      if(v){
        this.erroinfo='';
        this.form.code='';
        clearInterval(this.time);
        this.disabled=0;
        this.$nextTick(v=>{
          this.$refs.form&&this.$refs.form.clearValidate();
        })
      }
    }
  },
  methods: {
    async getcode(){
      let t=this;
      t.disabled=59;
      let res=await api.sendCode(this.$store.state.user.telPhone);
      this.$message.success(res.data.data);
      this.time=setInterval(v=>{
        --t.disabled;
        if(t.disabled<1){
          clearInterval(this.time)
        }
      },1000)
    },
    center(){
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.$emit('end',this.form);
        //this.show=false;
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.borderlan{
  border-color: #0286DF !important;
  color: #0286DF !important;;
  &:hover{
    border-color: #0286DF !important;;
    color: #0286DF !important;;
  }
}
  .el-button--primary {
    color: #fff;
    border-color: #B79255;
    background: #B79255;
    &:hover,&:focus{
    color: #fff;
    border-color: #B79255;
    background: #B79255;
    }
  }
</style>
